import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClubImage from '../../../../components/ClubImage/ClubImage';
import { LiteraryGenre } from '../../../../models/literaryGenre';
import { getClubIdByPathname, getClubNameByPathname, navigateToClub } from '../../../../utils/club';

import styles from './Profile.module.scss';

interface Props {
  description: string;
  genres: LiteraryGenre[];
  name: string;
  pathPhoto: string;
  pagesReaded: number;
  booksReaded: number;
  members: number;
  navigate: (path: string) => void;
}

const Profile = ({navigate, description, pathPhoto, name, genres, pagesReaded, booksReaded, members}:Props) => {

  const clubId = getClubIdByPathname();
  const clubName = getClubNameByPathname();
  
  return (
    <section className={styles.container}>
      <header className={styles.containerHeader}>
        <div>
          <ClubImage clubName={name} path={pathPhoto}/>
        </div>
        <div className={styles.containerInformation}>
          <h1 className={styles.name}><strong>{name}</strong></h1>
          {!!genres.length && <h2 className={styles.genres}>Gêneros: {genres.map(genre => genre.content).join(', ')}</h2>} 
        </div>
      </header>
      <p className={styles.description}>{description}</p>
      <div className={styles.readerContainer}>
        <div className={styles.readerInfo} onClick={() => navigate(navigateToClub(clubName, clubId, '/bookcase'))}>
          <span>{pagesReaded}</span><br/>
          <span>páginas lidas</span>
        </div>
        <div className={styles.readerInfo} onClick={() => navigate(navigateToClub(clubName, clubId, '/bookcase'))}>
          <span>{booksReaded}</span><br/>
          <span>livros lidos</span>
        </div>
        <div className={styles.readerInfo} onClick={() => navigate(navigateToClub(clubName,clubId, '/members'))}>
          <span>{members}</span><br/>
          <span>Membros</span>
        </div>
      </div>
    </section>
  )
}

export default Profile;